// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sidebar_sb__2FFOZ {
  background-color: var(--color-fash-black);
  color: var(--color-white);
  box-sizing: border-box;
  padding: 4rem 2rem;
  min-height: 100vh;
  cursor: pointer;
  width: 30vw;
  transition: all 850ms;
  position: relative;
}
@media only screen and (max-width: 50em) {
  .Sidebar_sb__2FFOZ {
    width: 40vw;
  }
}
@media only screen and (max-width: 37.5em) {
  .Sidebar_sb__2FFOZ {
    width: 70vw;
  }
}
.Sidebar_sb_title__J-JnY {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 2rem;
}
.Sidebar_sb_title__J-JnY > :not(:last-child) {
  margin-right: 3rem;
}
.Sidebar_sb_icon__ugtjL {
  font-size: 3rem;
}
.Sidebar_sb_logo__seVEB {
  height: 3rem;
}
.Sidebar_sb_nav__PQmx8 {
  box-sizing: border-box;
  padding: 3rem 1rem;
  height: 87vh;
  overflow-y: auto;
}
.Sidebar_sb_nav__PQmx8::-webkit-scrollbar {
  width: 0.5rem;
  background-color: var(--color-white);
}
.Sidebar_sb_nav__PQmx8::-webkit-scrollbar-thumb {
  background-color: var(--color-grey);
}
.Sidebar_sb_nav_2__4Up7Z {
  box-sizing: border-box;
  height: 50vh;
  padding: 3rem 1rem;
  overflow-y: auto;
}
@media only screen and (max-width: 81.25em) {
  .Sidebar_sb_nav_2__4Up7Z {
    height: 50vh;
  }
}
@media only screen and (max-width: 62.5em) {
  .Sidebar_sb_nav_2__4Up7Z {
    height: 60vh;
  }
}
@media only screen and (max-width: 37.5em) {
  .Sidebar_sb_nav_2__4Up7Z {
    height: 57vh;
  }
}
@media only screen and (max-width: 25em) {
  .Sidebar_sb_nav_2__4Up7Z {
    height: 52vh;
  }
}
.Sidebar_sb_nav_2__4Up7Z::-webkit-scrollbar {
  width: 0.5rem;
  background-color: var(--color-white);
}
.Sidebar_sb_nav_2__4Up7Z::-webkit-scrollbar:active, .Sidebar_sb_nav_2__4Up7Z::-webkit-scrollbar:hover {
  width: 1rem;
}
.Sidebar_sb_nav_2__4Up7Z::-webkit-scrollbar-thumb {
  background-color: var(--color-grey);
}
.Sidebar_sb_nav_ul__Uzdq4 {
  display: flex;
  flex-direction: column;
  align-items: space-evenly;
  margin: 0;
  padding: 0;
  gap: 1rem;
  list-style: none;
}
.Sidebar_sb_nav_ul__Uzdq4 > * {
  padding: 0.75rem 2rem;
  list-style: none;
}
.Sidebar_sb_nav_item__0fWwv {
  font-size: var(--default-font-small);
  font-weight: 700;
}
.Sidebar_sb_nav_item_active__jmti1, .Sidebar_sb_nav_item__0fWwv:hover {
  background-color: var(--color-white);
  color: var(--color-dark);
  border-radius: 0.75rem;
}
.Sidebar_sb_nav_link__k6Hd2 {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.Sidebar_sb_nav_link_icon__BMDvJ {
  font-size: 2rem;
}
.Sidebar_sb_nav_link_arr__pJBKt {
  font-size: 2rem;
  transform: rotateX(180deg);
}
.Sidebar_sb_nav_link_arr_1__c6D1r {
  font-size: 2rem;
}
.Sidebar_sb_nav_link_group__iMt42 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.Sidebar_subNav_ul__hx4S3 {
  display: flex;
  flex-direction: column;
  align-items: space-evenly;
  margin: 1rem 0;
  padding: 0;
  gap: 0.5rem;
  list-style: none;
}
.Sidebar_subNav_ul__hx4S3 > * {
  padding: 0.75rem 3rem;
  list-style: none;
}
.Sidebar_subNav_li_active__J3\\+0M, .Sidebar_subNav_li__If3Zp:hover {
  background-color: var(--color-fash-black);
  color: var(--color-white);
  border-radius: 0.75rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Components/Sidebar.module.scss"],"names":[],"mappings":"AAEA;EACE,yCAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;AADF;AAGE;EAXF;IAYI,WAAA;EAAF;AACF;AAEE;EAfF;IAgBI,WAAA;EACF;AACF;AACE;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;AACJ;AACI;EACE,kBAAA;AACN;AAGE;EACE,eAAA;AADJ;AAIE;EACE,YAAA;AAFJ;AAKE;EACE,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;AAHJ;AAKI;EACE,aAAA;EACA,oCAAA;AAHN;AAMI;EACE,mCAAA;AAJN;AAOI;EACE,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AALN;AAOM;EANF;IAOI,YAAA;EAJN;AACF;AAMM;EAVF;IAWI,YAAA;EAHN;AACF;AAKM;EAdF;IAeI,YAAA;EAFN;AACF;AAIM;EAlBF;IAmBI,YAAA;EADN;AACF;AAGM;EACE,aAAA;EACA,oCAAA;AADR;AAGQ;EAEE,WAAA;AAFV;AAMM;EACE,mCAAA;AAJR;AAQI;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AANN;AAQM;EACE,qBAAA;EACA,gBAAA;AANR;AAUI;EACE,oCAAA;EACA,gBAAA;AARN;AAUM;EAEE,oCAAA;EACA,wBAAA;EACA,sBAAA;AATR;AAaI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAXN;AAaM;EACE,eAAA;AAXR;AAcM;EACE,eAAA;EACA,0BAAA;AAZR;AAcQ;EACE,eAAA;AAZV;AAgBM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAdR;;AAqBE;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;AAlBJ;AAoBI;EACE,qBAAA;EACA,gBAAA;AAlBN;AAwBI;EAEE,yCAAA;EACA,yBAAA;EACA,sBAAA;AAvBN","sourcesContent":["@import \"../variables/breakpoints\";\n\n.sb {\n  background-color: var(--color-fash-black);\n  color: var(--color-white);\n  box-sizing: border-box;\n  padding: 4rem 2rem;\n  min-height: 100vh;\n  cursor: pointer;\n  width: 30vw;\n  transition: all 850ms;\n  position: relative;\n\n  @media only screen and (max-width: $bp-medium) {\n    width: 40vw;\n  }\n\n  @media only screen and (max-width: $bp-small) {\n    width: 70vw;\n  }\n\n  &_title {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    padding-left: 2rem;\n\n    &> :not(:last-child) {\n      margin-right: 3rem;\n    }\n  }\n\n  &_icon {\n    font-size: 3rem;\n  }\n\n  &_logo {\n    height: 3rem;\n  }\n\n  &_nav {\n    box-sizing: border-box;\n    padding: 3rem 1rem;\n    height: 87vh;\n    overflow-y: auto;\n\n    &::-webkit-scrollbar {\n      width: 0.5rem;\n      background-color: var(--color-white);\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background-color: var(--color-grey);\n    }\n\n    &_2 {\n      box-sizing: border-box;\n      height: 50vh;\n      padding: 3rem 1rem;\n      overflow-y: auto;\n\n      @media only screen and (max-width: $bp-1300) {\n        height: 50vh;\n      }\n\n      @media only screen and (max-width: $bp-1000) {\n        height: 60vh;\n      }\n\n      @media only screen and (max-width: $bp-600) {\n        height: 57vh;\n      }\n\n      @media only screen and (max-width: $bp-400) {\n        height: 52vh;\n      }\n\n      &::-webkit-scrollbar {\n        width: 0.5rem;\n        background-color: var(--color-white);\n\n        &:active,\n        &:hover {\n          width: 1rem;\n        }\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background-color: var(--color-grey);\n      }\n    }\n\n    &_ul {\n      display: flex;\n      flex-direction: column;\n      align-items: space-evenly;\n      margin: 0;\n      padding: 0;\n      gap: 1rem;\n      list-style: none;\n\n      &>* {\n        padding: 0.75rem 2rem;\n        list-style: none;\n      }\n    }\n\n    &_item {\n      font-size: var(--default-font-small);\n      font-weight: 700;\n\n      &_active,\n      &:hover {\n        background-color: var(--color-white);\n        color: var(--color-dark);\n        border-radius: 0.75rem;\n      }\n    }\n\n    &_link {\n      display: flex;\n      align-items: center;\n      gap: 1rem;\n\n      &_icon {\n        font-size: 2rem;\n      }\n\n      &_arr {\n        font-size: 2rem;\n        transform: rotateX(180deg);\n\n        &_1 {\n          font-size: 2rem;\n        }\n      }\n\n      &_group {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n      }\n    }\n  }\n}\n\n.subNav {\n  &_ul {\n    display: flex;\n    flex-direction: column;\n    align-items: space-evenly;\n    margin: 1rem 0;\n    padding: 0;\n    gap: 0.5rem;\n    list-style: none;\n\n    &>* {\n      padding: 0.75rem 3rem;\n      list-style: none;\n    }\n  }\n\n  &_li {\n\n    &_active,\n    &:hover {\n      background-color: var(--color-fash-black);\n      color: var(--color-white);\n      border-radius: 0.75rem;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sb": `Sidebar_sb__2FFOZ`,
	"sb_title": `Sidebar_sb_title__J-JnY`,
	"sb_icon": `Sidebar_sb_icon__ugtjL`,
	"sb_logo": `Sidebar_sb_logo__seVEB`,
	"sb_nav": `Sidebar_sb_nav__PQmx8`,
	"sb_nav_2": `Sidebar_sb_nav_2__4Up7Z`,
	"sb_nav_ul": `Sidebar_sb_nav_ul__Uzdq4`,
	"sb_nav_item": `Sidebar_sb_nav_item__0fWwv`,
	"sb_nav_item_active": `Sidebar_sb_nav_item_active__jmti1`,
	"sb_nav_link": `Sidebar_sb_nav_link__k6Hd2`,
	"sb_nav_link_icon": `Sidebar_sb_nav_link_icon__BMDvJ`,
	"sb_nav_link_arr": `Sidebar_sb_nav_link_arr__pJBKt`,
	"sb_nav_link_arr_1": `Sidebar_sb_nav_link_arr_1__c6D1r`,
	"sb_nav_link_group": `Sidebar_sb_nav_link_group__iMt42`,
	"subNav_ul": `Sidebar_subNav_ul__hx4S3`,
	"subNav_li_active": `Sidebar_subNav_li_active__J3+0M`,
	"subNav_li": `Sidebar_subNav_li__If3Zp`
};
export default ___CSS_LOADER_EXPORT___;
